<template>
  <Menu
    :active-name="$store.state.slectedItem"
    theme="light"
    width="auto"
    :open-names="[$store.state.menus[0].id]"
    @on-select="changeNav"
  >
    <Submenu v-for="(item,index) in $store.state.menus" :key="index" :name="item.id">
      <template slot="title">
        <Icon :type="item.icon"></Icon>
        {{item.name}}
      </template>
      <MenuItem v-for="(m,i) in item.children" :key="i" :name="m.id">{{m.name}}</MenuItem>
    </Submenu>
  </Menu>
</template>
<script>
export default {
  methods: {
    changeNav(name) {
      // console.log(this.$store.state.menus);
      let menus = this.$store.state.menus;
      let slide ;
      for(let i in menus){
        for(let j in menus[i].children){
          if(menus[i].children[j].id === name){
            slide = menus[i].children[j].path;
          }
        }
      }
      // console.log(slide)
      this.$router.push(slide)
      this.$store.commit("setTags", name);
    }
  }
};
</script>

<style lang="less" scoped>
.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/index/YnSlider.vue